import { STATES, ITEM_KINDS, STEP_URLS } from '@mover-app/constants';

export const BASE_PATH = STEP_URLS.STEP_MOVE_YOUR_STUFF;
export function MoveYourStuffConfig($stateProvider) {
  'ngInject';

  $stateProvider.state(STATES.STEP_MOVE_YOUR_STUFF, {
    url: `${BASE_PATH}`,
    disableBreadcrumb: true,
    title: 'Move Your Stuff',
    views: {
      '@': {
        template: '<div>Move Your Stuff</div>',
      },
    },
    scrollTop: true,
    data: {
      permissions: 'signedIn',
      moveItem: {
        type: ITEM_KINDS.MOVE_YOUR_STUFF,
        singleton: true,
      },
    },
    resolve: {
      guard: () => {
        // Make sure to never resolve so that back works on the next page.
        return new Promise(() => {
          window.location.href = '/n/quick-setup/move-your-stuff';
        });
      },
    },
  });
}
